import React, { Component } from 'react';

class ProductImageSign extends Component {
  render() {
    return <div className="ProductSign">{this.props.children}</div>;
  }
}

export default ProductImageSign;



// WEBPACK FOOTER //
// ./src/components/product/ProductSign/index.jsx